import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { WorkerService } from '@/infra/services/worker';
import { validateUuid } from '@/utils/validate-uuid';

interface GetListWorkerParams {
	organization_id: string;
	company_id: string;
	name?: string;
	limit?: number;
	offset?: number;
}

const Service = WorkerService.getInstance();

export const useGetListWorker = (params: GetListWorkerParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id]);
	return useQuery({
		queryKey: [QUERY_KEYS.GET_LIST_WORKER, params],
		queryFn: async () => Service.index(params),
		enabled: isEnabled
	});
};
